import { HttpResponseDto,PaginatedUserAuditLogDto, UserAuditLog } from '@/common/api/datasources/Api';
import { api } from '@/common/api/instance';

type AuditAction = 
    | "UPDATE_PROFILE"
    | "DELETE_PROFILE"
    | "CHANGE_PASSWORD"
    | "CHANGE_EMAIL"
    | "CHANGE_PHONE"
    | "UPDATE_NOTIFICATIONS"
    | "UPDATE_SETTINGS"
    | "ACTIVATE_ACCOUNT"
    | "DEACTIVATE_ACCOUNT"
    | "BLOCK_ACCOUNT"
    | "LOGIN"
    | "LOGOUT"
    | "FAILED_LOGIN"
    | "EMAIL_VERIFIED"
    | "PHONE_VERIFIED"
    | "CHANGE_ROLE";

interface AuditLogFilters {
    page?: number;
    size?: number;
    userId: string;
    action?: AuditAction;
    startDate?: string;
    endDate?: string;
}

export const userAuditLogsService = {
    getAuditLogs: async (filters: AuditLogFilters): Promise<PaginatedUserAuditLogDto> => {
        const response = await api.userAuditLogs.userAuditLogsControllerFindLogs(filters);
        return response.data;
    },

    deleteAuditLog: async (id: string): Promise<HttpResponseDto> => {
        const response = await api.userAuditLogs.userAuditLogsControllerDeleteAuditLog(id);
        return response.data;
    },
};

export const useUserAuditLogsQuery = () => ({
    auditLogsQuery: (filters: AuditLogFilters) => ({
        queryKey: ['user-audit-logs', filters],
        queryFn: () => userAuditLogsService.getAuditLogs(filters),
    }),

    deleteAuditLogMutation: {
        mutationFn: (id: string) => userAuditLogsService.deleteAuditLog(id),
    },
}); 